import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Shield, Mail, FileText } from 'lucide-react';

const DmcaPage = () => {
  return (
    <div className="min-h-screen bg-black">
      {/* Header */}
      <header className="bg-black/95 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center space-x-4">
            <Link to="/">
              <Button variant="ghost" className="text-white/70 hover:text-white">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Home
              </Button>
            </Link>
            <div className="h-6 w-px bg-white/20"></div>
            <h1 className="text-xl font-brand font-bold bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent">
              DMCA Notice & Takedown Policy
            </h1>
          </div>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <Card className="glass-premium">
          <CardContent className="p-8">
            <div className="flex items-center space-x-3 mb-8">
              <div className="w-12 h-12 bg-gradient-to-br from-pink-500 to-purple-600 rounded-lg flex items-center justify-center">
                <Shield className="h-6 w-6 text-white" />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-white">DMCA Policy</h1>
                <p className="text-white/70">Digital Millennium Copyright Act Compliance</p>
              </div>
            </div>

            <div className="prose prose-invert max-w-none space-y-8 text-white/80 leading-relaxed">
              <section>
                <h2 className="text-2xl font-bold text-white mb-4 flex items-center">
                  <FileText className="h-5 w-5 mr-2 text-pink-400" />
                  Our Commitment to Copyright Protection
                </h2>
                <p>
                  usexxx respects the intellectual property rights of others and expects our users to do the same. 
                  We have adopted and implemented a policy that provides for the removal of any infringing material from our website.
                </p>
                <p>
                  We also provide for the termination of users who are repeat infringers. If you believe that your copyrighted work 
                  is being used on our website in a way that constitutes copyright infringement, please provide our designated 
                  copyright agent with the following information:
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">DMCA Takedown Requirements</h2>
                <div className="bg-pink-500/10 border border-pink-500/20 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-pink-300 mb-3">Required Information for DMCA Notice:</h3>
                  <ul className="list-disc list-inside space-y-2 text-white/80">
                    <li>A physical or electronic signature of the copyright owner or authorized agent</li>
                    <li>Identification of the copyrighted work claimed to have been infringed</li>
                    <li>Identification of the infringing material and its location on our website</li>
                    <li>Your contact information (address, telephone number, email address)</li>
                    <li>A statement that you have a good faith belief that the use is not authorized</li>
                    <li>A statement that the information is accurate and you are authorized to act on behalf of the copyright owner</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">How to Submit a DMCA Notice</h2>
                <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-6">
                  <div className="flex items-start space-x-3">
                    <Mail className="h-5 w-5 text-blue-400 mt-1" />
                    <div>
                      <h3 className="text-lg font-semibold text-blue-300 mb-2">Contact Our DMCA Agent:</h3>
                      <div className="space-y-1 text-white/80">
                        <p><strong>Email:</strong> dmca@usexxx.com</p>
                        <p><strong>Subject Line:</strong> DMCA Takedown Request</p>
                        <p><strong>Response Time:</strong> 24-48 hours</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">Counter-Notice Procedure</h2>
                <p>
                  If you believe that your material was removed or disabled by mistake or misidentification, you may file a 
                  counter-notice with us by providing our designated copyright agent with the following information:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Your physical or electronic signature</li>
                  <li>Identification of the material and its location before removal</li>
                  <li>A statement under penalty of perjury that the material was removed by mistake</li>
                  <li>Your contact information and consent to jurisdiction</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">Repeat Infringer Policy</h2>
                <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-6">
                  <p className="text-red-300">
                    <strong>Important:</strong> Users who are found to be repeat infringers will have their accounts terminated. 
                    We maintain a strict policy against copyright infringement and take all claims seriously.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">Safe Harbor Provisions</h2>
                <p>
                  usexxx operates under the safe harbor provisions of the Digital Millennium Copyright Act. We do not 
                  actively monitor user-uploaded content but respond promptly to valid DMCA takedown notices.
                </p>
              </section>

              <div className="border-t border-white/10 pt-8 mt-12">
                <p className="text-sm text-white/60">
                  <strong>Last Updated:</strong> January 2024<br />
                  <strong>Effective Date:</strong> Immediately upon posting
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default DmcaPage;